module.exports = __webpack_public_path__ + "img/symbol_9.3e0e89a0.png";